module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.6adc6777.jpeg";